var map = {
	"./logo-bca_qris-active.svg": "3d01",
	"./logo-bca_qris2-active.svg": "ab0f",
	"./logo-gopay_qris-active.svg": "79ce",
	"./logo-linkaja_qris-active.svg": "26d2",
	"./logo-ovo_qris-active.svg": "06a6",
	"./logo-ovo_qris2-active.svg": "88f6",
	"./logo-shopeepay_qris-active.svg": "3320"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3cb87";